export enum TourIds {
    assistantReplacement = 'assistant-replacement',
    fileUpload = 'file-upload',
    assistantCatalog = 'assistant-catalog',
}
